import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-24b74306")

_pushScopeId("data-v-24b74306")
const _hoisted_1 = /*#__PURE__*/_createVNode("div", null, [
  /*#__PURE__*/_createVNode("h2", null, "営業時間登録")
], -1)
const _hoisted_2 = /*#__PURE__*/_createVNode("h3", null, "基準日", -1)
const _hoisted_3 = { class: "vue-content-edit-box" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("戻る ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("登録 ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("登録してもいいですか？ ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_vue_title = _resolveComponent("vue-title")
  const _component_vue_content_item_frame = _resolveComponent("vue-content-item-frame")
  const _component_repeat = _resolveComponent("repeat")
  const _component_time_range = _resolveComponent("time-range")
  const _component_vue_content = _resolveComponent("vue-content")
  const _component_normal_button = _resolveComponent("normal-button")
  const _component_vue_button_frame = _resolveComponent("vue-button-frame")
  const _component_confirm = _resolveComponent("confirm")
  const _component_vue_frame = _resolveComponent("vue-frame")

  return (_openBlock(), _createBlock(_component_vue_frame, null, {
    default: _withId(() => [
      _createVNode(_component_vue_title, null, {
        default: _withId(() => [
          _hoisted_1
        ]),
        _: 1
      }),
      _createVNode(_component_vue_content, null, {
        default: _withId(() => [
          _createVNode("div", null, [
            _hoisted_2,
            _createVNode(_component_vue_content_item_frame, null, {
              default: _withId(() => [
                _createVNode("div", _hoisted_3, _toDisplayString(_ctx.baseDateString), 1)
              ]),
              _: 1
            })
          ]),
          _createVNode(_component_repeat),
          _createVNode(_component_time_range)
        ]),
        _: 1
      }),
      _createVNode(_component_vue_button_frame, null, {
        left: _withId(() => [
          _createVNode(_component_normal_button, {
            class: "vue-button-frame-button",
            state: "normal",
            onClick: _ctx.back
          }, {
            default: _withId(() => [
              _hoisted_4
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        right: _withId(() => [
          _createVNode(_component_normal_button, {
            class: "vue-button-frame-button",
            state: "warning",
            onClick: _ctx.onSubmit
          }, {
            default: _withId(() => [
              _hoisted_5
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _: 1
      }),
      _createVNode(_component_confirm, {
        ref: "confirmRef",
        onYes: _ctx.yes
      }, {
        default: _withId(() => [
          _hoisted_6
        ]),
        _: 1
      }, 8, ["onYes"])
    ]),
    _: 1
  }))
})